import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { usePlaylistCompletionContext } from 'components/PlaylistCompletionProvider';
import hasAutoCompleteEnabled from 'utils/asset/hasAutoCompleteEnabled';
import { useMarkMyAssetAsDone } from 'actions/assets';
// Note: this function should be refactored and simplified so it can be moved to common/utils
function useOnWebAssetClick() {
  var _usePlaylistCompletio = usePlaylistCompletionContext(),
    setCompletedPlaylists = _usePlaylistCompletio.setCompletedPlaylists;
  var _useMarkMyAssetAsDone = useMarkMyAssetAsDone({
      setCompletedPlaylists: setCompletedPlaylists,
      shouldShowModalImmediately: true
    }),
    markMyAssetAsDone = _useMarkMyAssetAsDone.markMyAssetAsDone;
  function onWebAssetClick(_x) {
    return _onWebAssetClick.apply(this, arguments);
  }
  function _onWebAssetClick() {
    _onWebAssetClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var type, markAsDoneMode, userContentStatus, contentId, parentPlaylistId, autoCompleteEnabled;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = _ref.type, markAsDoneMode = _ref.markAsDoneMode, userContentStatus = _ref.userContentStatus, contentId = _ref.contentId, parentPlaylistId = _ref.parentPlaylistId;
            if (!(type !== 'web')) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            autoCompleteEnabled = hasAutoCompleteEnabled({
              assetType: type,
              markAsDoneMode: markAsDoneMode
            });
            if (!(autoCompleteEnabled && userContentStatus !== 'completed')) {
              _context.next = 2;
              break;
            }
            _context.next = 2;
            return markMyAssetAsDone({
              id: contentId,
              playlistId: parentPlaylistId
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onWebAssetClick.apply(this, arguments);
  }
  return {
    onWebAssetClick: onWebAssetClick
  };
}
export default useOnWebAssetClick;